import { createSlice } from '@reduxjs/toolkit';
import * as authService from '../../services/auth';
import { AuthTokenStorage, JWToken } from '../../common/authTokenStorage';
import { ComplexError } from '../../common/complexError';

const initialState = {
  loggedIn: false,
  error: null,
  inSession: false,
  tokenRefreshingPromise: null,
  userName: null,
  allowWrite: false,
};

const auth = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    authLoggedIn: (state) => {
      state.loggedIn = true;
      state.error = null;
      state.inSession = false;
      state.userName = null;
      state.allowWrite = false;
    },
    authLoginSuccess: (state, action) => {
      const { name, allowWrite } = action.payload;
      state.error = null;
      state.loggedIn = false;
      state.inSession = true;
      state.userName = name;
      state.allowWrite = allowWrite;
    },
    authError: (state, action) => {
      const { error } = action.payload;
      state.error = error;
      state.loggedIn = false;
      state.inSession = false;
      state.userName = null;
      state.allowWrite = false;
    },
    authLogout: (state) => {
      AuthTokenStorage.removeTokens();
      state.error = null;
      state.loggedIn = false;
      state.inSession = false;
      state.userName = null;
      state.allowWrite = false;
    },
    authRefreshToken: (state, action) => {
      const { promise } = action.payload;
      state.tokenRefreshingPromise = promise;
    },
    authTokenRefreshingDone: (state) => {
      state.tokenRefreshingPromise = null;
    },
  },
});

const { reducer, actions } = auth;

export const {
  authLoggedIn, authLoginSuccess, authError, authLogout,
  authRefreshToken, authTokenRefreshingDone,
} = actions;

export const login = (login, password) => (dispatch) => {
  dispatch(authLoggedIn());
  return authService.login(login, password)
    .then(tokens => {
      const rjwt = new JWToken(tokens.accessToken);
      if (rjwt.parse()) {
        AuthTokenStorage.setTokens(tokens.accessToken, tokens.refreshToken);
        return dispatch(authLoginSuccess({
          name: rjwt.login,
          allowWrite: rjwt.allowWrite,
        }));
      }
      const error = new ComplexError();
      error.clientMessage = "Incorrect access token format";
      return dispatch(authError({ error }));
    })
    .catch(error => {
      error.clientMessage = "Could not log in";
      return dispatch(authError({ error }));
    });
};

export const logout = (dispatch) => dispatch(authLogout());

export const authSelectors = {
  allowWrite: (state) => state.auth.allowWrite,
};

export default reducer;



// WEBPACK FOOTER //
// ./src/store/auth/authSlice.js